import { httpClient } from '@/api/http-client'
import { PartnerPayload } from '@/types/partner'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type Params = {
  companyKey: string
  partnerKey: string
  partnerData: PartnerPayload
}

export const useUpdatePartner = (
  options?: UseMutationOptions<void, AxiosError, Params>,
) => {
  const updatePartner = async ({
    companyKey,
    partnerKey,
    partnerData,
  }: Params): Promise<void> => {
    const response = await httpClient('accounting-dealer').put(
      `v3/company/${companyKey}/partner/${partnerKey}`,
      partnerData,
    )
    return response.data
  }

  return useMutation({
    mutationFn: updatePartner,
    ...options,
  })
}
